export const services = [
  {
    id: 'serv-001',
    name: 'Baño completo',
    description: 'Baño con shampoo especial, secado y cepillado',
    duration: 60,
    price: 35000,
    category: 'Aseo',
    icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    requiresAppointment: true
  },
  {
    id: 'serv-002',
    name: 'Paseo recreativo',
    description: 'Paseo de 30 minutos en parque cercano',
    duration: 30,
    price: 15000,
    category: 'Ejercicio',
    icon: 'M8 7l4-4 4 4m0 0l-4 4-4-4m4 4v12',
    requiresAppointment: false
  }
];

export const bookings = [
  {
    id: 'book-001',
    serviceId: 'serv-001',
    petId: 'pet-001',
    date: '2023-06-15',
    time: '10:00',
    caregiverId: 'user-004',
    status: 'confirmed',
    notes: 'Alergia al perfume'
  }
];

export const serviceHistory = [
  {
    id: 'hist-001',
    serviceId: 'serv-001',
    petId: 'pet-001',
    date: '2023-06-10',
    caregiverId: 'user-004',
    rating: 5,
    comment: 'Excelente servicio, mi perro quedó muy limpio y contento'
  }
];

export const pets = [
  {
    id: 'pet-001',
    name: 'Max',
    ownerId: 'user-001'
  }
];

export const users = [
  { id: 'user-001', name: 'Juan Pérez', role: 'owner' },
  { id: 'user-004', name: 'Ana Cuidadora', role: 'caregiver' }
];